module.exports = __webpack_public_path__ + "img/im.be893035.svg";